import Vuex, { Store, StoreOptions, Getter, ActionContext } from 'vuex';
import { computed } from '@vue/composition-api';
import { State } from './abstractions';

// Mutations

function setLoading(state: State, loading: boolean) {
    if (state == null) { return }

    if (loading) {
        state.isLoading += 1;
    }
    else {
        state.isLoading -= 1;
    }
}

function setLang(state: State, lang: string) {
    if (state == null) { return }

    state.lang = lang;
}

function setSnackbar(state: State, snackbar: any) {
    if (state == null) { return }

    state.snackbar = snackbar;
}

function clearSnackbar(state: State) {
    if (state == null) { return }

    state.snackbar = null;
}

function setTheme(state: State, theme: string) {
    if (state == null) { return }

    state.theme = theme;
}

function setClientApp(state: State, app: string) {
    if (state == null) { return }

    state.clientApp = app;
}

function setIsDevelopment(state: State, isDevelopment: boolean) {
    if (state == null) { return }

    state.isDevelopment = isDevelopment;
}

function invalidateCache(state: State, keys: string[]) {
    if (state == null) { return }

    for (let key of keys) {
        state.cacheControl[key] = 'reload';
    }
}

function updateAuthentication(state: State, update: { result: 'OK' | 'ERROR', user: User }) {
    if (update.result == 'OK' && !!update.user) {
        state.isAuthenticated = true;
        state.loggedUser = update.user;
    }
    else {
        state.isAuthenticated = false;
        state.loggedUser = null;
        state.userPlants = null;
    }
}

function updateUserPlants(state: State, update: { result: 'OK' | 'ERROR', plantsInfo: PlantInfo[] }) {
    if (update.result == 'OK' && !!update.plantsInfo) {
        state.userPlants = update.plantsInfo;
    }
    else {
        state.userPlants = null;
    }
}

function updateSharingInfo(state: State, info: UserShareInfo) {
    if (!state.shareInfo) {
        state.shareInfo = {
            user: null,
            share: {
                status: null
            }
        }
    }
    state.shareInfo.user = info
}

function updateSharingStatus(state: State, status: string) {
    if (!state.shareInfo) {
        state.shareInfo = {
            user: null,
            share: {
                status: null
            }
        }
    }
    state.shareInfo.share.status = status;
    console.log(state)
}

// Initial state and store options

const state: State = {
    isDevelopment: true,
    isLoading: 0,

    lang: 'it',
    snackbar: null,
    theme: 'light-alt',

    cacheControl: {},

    isAuthenticated: false,
    loggedUser: null,

    userPlants: null,

    clientApp: null,
    shareInfo: null
}

import { actions as mainActions } from './actions';
import { PlantInfo, ShareInfo, User, UserShareInfo } from '@/model';

const OPTIONS: StoreOptions<State> = {
    state,
    actions: {
        ...mainActions
    },
    mutations: {
        setLoading,
        setIsDevelopment,
        setLang,
        setSnackbar,
        setClientApp,
        clearSnackbar,
        setTheme,
        invalidateCache,
        updateAuthentication,
        updateUserPlants,
        updateSharingInfo,
        updateSharingStatus
    },
    getters: {
    }
}

let store: Store<State> = null;

export function getStore() {
    if (store == null) {
        store = new Vuex.Store(OPTIONS);
    }
    return store;
}

// Snackbar utilities

export function showSnackbar(text: string) {
    store.commit('setSnackbar', {
        message: text
    });
}

export function showSnackbarSuccess(text: string) {
    store.commit('setSnackbar', {
        kind: 'success',
        message: text
    });
}

export function showSnackbarError(text: string) {
    store.commit('setSnackbar', {
        kind: 'error',
        message: text
    });
}

export function hideSnackbar() {
    store.commit('clearSnackbar');
}

// Theme utilities

export function setThemeLight() {
    store.commit('setTheme', 'light');
}

export function setThemeLightAlt() {
    store.commit('setTheme', 'light-alt');
}

export function setThemeDark() {
    store.commit('setTheme', 'dark');
}

export function setThemeDarkAlt() {
    store.commit('setTheme', 'dark-alt');
}
